import { PythonTopic } from '../../../../types/python-topic';
import { complejidadOrganizacionExercises } from './exercises';

export const complejidadOrganizacionTopic: PythonTopic = {
  id: 5,
  title: 'Complejidad y Organización de programas',
  description: 'Aprende a organizar código en scripts y módulos, funciones avanzadas, y entender complejidad algorítmica.',
  theory: `# Complejidad y Organización de Programas

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a:
1. **Scripts**: Organizar código en archivos ejecutables
2. **Funciones avanzadas**: Funciones más complejas y poderosas
3. **Módulos**: Organizar código en módulos reutilizables
4. **Búsqueda binaria**: Algoritmo de búsqueda eficiente
5. **Complejidad algorítmica**: Entender eficiencia de algoritmos

## Organización de Código

Aprenderás a:
- Estructurar programas en múltiples archivos
- Crear módulos reutilizables
- Organizar código de forma profesional

## Complejidad Algorítmica

Entenderás:
- Notación Big O
- Eficiencia de algoritmos
- Cómo elegir el algoritmo correcto

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo.`,
  difficulty: 'advanced',
  exercises: complejidadOrganizacionExercises
};

